import { type Action, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import sessionStorage from "redux-persist/es/storage/session";
import type { ThunkAction } from "redux-thunk";
import appDesignReducer from "./slices/appDesignSlice";
import authReducer from "./slices/auth";
import costEffectivenessReducer from "./slices/costEffectivenessSlice";
import creditsReducer from "./slices/creditsSlice";
import customizeSpecificationListReducer from "./slices/customizeSpecificationListSlice";
import customizeSpecificationReducer from "./slices/customizeSpecificationSlice";
import fieldDesignReducer from "./slices/fieldDesignSlice";
import functionalRequirementReducer from "./slices/functionalRequirementSlice";
import nonFunctionalRequirementReducer from "./slices/nonFunctionalRequirementSlice";
import organizationReducer from "./slices/organizationSlice";
import pluginProposalReducer from "./slices/pluginProposalSlice";
import projectReducer from "./slices/projectSlice";
import reverseEngineeringReducer from "./slices/reverseEngineeringSlice";
import systemProposalReducer from "./slices/systemProposalSlice";

const persistConfig = {
  key: "root", // ストレージに保存するキー
  storage: sessionStorage, // 使用するストレージ
};

// authReducerを永続化するために、persistReducerを使用
const persistedAuthReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    credits: creditsReducer,
    organization: organizationReducer,
    systemProposalReducer: systemProposalReducer,
    nonFunctionalRequirement: nonFunctionalRequirementReducer,
    functionalRequirement: functionalRequirementReducer,
    pluginProposal: pluginProposalReducer,
    appDesign: appDesignReducer,
    customizeSpecification: customizeSpecificationReducer,
    customizeSpecificationList: customizeSpecificationListReducer,
    fieldDesign: fieldDesignReducer,
    costEffectiveness: costEffectivenessReducer,
    project: projectReducer,
    reverseEngineering: reverseEngineeringReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
});

// persistorの作成
export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
